import styled, { keyframes } from 'styled-components';

const fadeFromRight = keyframes`
from {
  opacity: 0;
  transform: translateX(50px);
}
to{
  opacity: 1;
  transform:translateX(0);
}
`;
export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 30px 0px;
  background: #ddd;
  width: 100%;

  >h2{
    color: #333;
    font-size: 24px;
    margin-bottom: 20px;
  }

  >p{
    color: #333;
    font-size: 18px;
    margin-bottom: 20px;
  } 
  

  table{
    tr{
      &:hover{
      background: rgba(0,150,150,0.1);
    }
    }
  }

  .table {
    tr{
    background: rgba(255,255,255,1);
    color: #333;
    max-width: 100%;

  

  }
    tr:nth-child(even){
      background: rgba(255,255,255,0.8);
      &:hover{
      background: rgba(0,150,150,0.1);
    }
 
    }

    td{
      padding: 10px;
    }
  }
`;

export const Header = styled.div`
  width: 100%;
  background: none;
  color: #333;
  padding: 20px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    display: flex;
    max-width: 400px;
    form {
      display: flex;

      > input {
        border: 0;
        padding: 20px;
        background: #eee;
        color: #333;
      }
      > button {
        border: 0;
        padding: 20px;
        background: rgb(0, 100, 150);
        color: #fff;
      }
    }
  }
`;

export const Body = styled.div`
  width: 100%;
  min-height: 50vh;
  display: flex;

  > table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #ccc;
    table-layout: auto;
    background: white;
    margin-top: 10px;

    tr {
      td,
      th {
        border: 1px solid #ddd;
        text-align: left;
        color: #333;
        padding: 5px;
      }
    }

    tr + tr {
      border-top: 1px solid #999;
    }
  }
`;
